import { Icon, Input } from "@/components";
import polyglot from "@/utils/polyglot";
import { useQueryClient } from "@tanstack/react-query";
import { Field } from "formik";
import { useState } from "react";
import { StyledFormControl } from "../categoryForms/common/fields";
import StepTitle from "../categoryForms/common/StepTitle";
import { AddressModal } from "../common";

const AddressSelection = ({ title }) => {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(["recurring_jobs_form_data"]);

  const [addressModalIsOpen, setAddressModalIsOpen] = useState(false);

  return (
    <>
      <StepTitle>{title}</StepTitle>
      <StyledFormControl>
        <Field name="address">
          {({ field }) => (
            <Input
              name="address"
              onClick={() => setAddressModalIsOpen(true)}
              value={field.value}
              placeholder={polyglot.t("common.placeholder.job_address")}
              RightComponent={() => <Icon.Medium name="dropdown" />}
            />
          )}
        </Field>
        <AddressModal
          addresses={data?.addresses || []}
          isOpen={addressModalIsOpen}
          onClose={() => setAddressModalIsOpen(false)}
        />
      </StyledFormControl>
    </>
  );
};

export default AddressSelection;
